import React, { FC } from 'react';
import './nav-tags-list.sass';
import { IQueryParamFilters } from '../../../../shared/services/api.service';

export interface Props {
  tags: string[];
  handleOnNavItemClick: (payload: IQueryParamFilters) => void;
}

export const NavTagsList: FC<Props> = ({ tags, handleOnNavItemClick }) => {
  const filterPostsByTag = (tag?: string) => {
    const finalTags = tag ? tag : tags.join(',');
    handleOnNavItemClick({ tag: finalTags });
  };
  return (
    <div className="nav-list-tags">
      <div onClick={() => filterPostsByTag()} className="nav-list-tags__tag">
        All
      </div>
      {tags.map(tag => (
        <div onClick={() => filterPostsByTag(tag)} className="nav-list-tags__tag">
          {tag}
        </div>
      ))}
    </div>
  );
};

export default NavTagsList;
